<template>
	<v-row>
		<v-dialog v-model="showDialog" scrollable persistent max-width="1050px" min-height="400px">
			<v-skeleton-loader v-if="loading" type="article, actions" />
			<v-card v-if="!loading">
				<v-card-title class="px-2 py-0">
					<v-col cols="12" class="d-flex justify-space-between align-center">
						<h4>
							{{ !data.id ? $t('modules.config.dialog.title_new') : $t('modules.config.dialog.title_edit') }}
						</h4>
						<v-btn icon @click="showDialog=false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-col>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pb-0" @wheel="onWheel">
					<v-container>
						<v-form ref="form">
							<v-row class="mt-0">
								<v-col cols="6">
									<v-text-field
										v-model="data.name"
										:label="$t('modules.config.dialog.key')"
										autocomplete="none"
										:rules="[validationRules.required]"
										max="60"
									/>
								</v-col> 
								<v-col cols="6">
									<v-text-field
										v-model="data.value"
										:label="$t('modules.config.dialog.value')"
										autocomplete="none"
										:rules="[validationRules.required]"
										max="11000"
									/>
								</v-col> 
								<v-col cols="12">
									<v-text-field
										v-model="data.description"
										:label="$t('modules.config.dialog.description')"
										autocomplete="none"
										max="150"
									/>
								</v-col> 
								<v-col cols="6" class="pb-0">  
									<v-switch inset
										v-model="data.client"
										:label="$t('modules.config.dialog.client')"
										flat
										/>
								</v-col> 
								<v-col cols="6" class="pb-0">  
									<v-switch inset
										v-model="data.encrypted"
										:label="$t('modules.config.dialog.encrypted')"
										flat
										/>
								</v-col> 
							</v-row>
							<v-row class="mt-4">
								<v-col cols="12" class="pb-0">  
									<v-alert 
										v-if="showError" 
										type="error" 
										icon="mdi-alert">
										{{ $t('modules.config.dialog.exists_error') }}
									</v-alert>
								</v-col> 
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
						<v-icon left color="#ffffff">mdi-delete</v-icon>
						<span style="color: #ffffff;">{{ $t('common.dialog-buttons.delete') }}</span>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="#C3271A" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">
						{{ $t('common.dialog-buttons.ok') }}
					</v-btn>
					<v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">
						{{ $t('common.dialog-buttons.cancel') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>  
		<ConfirmDialog ref="dlgConfirm"
			:title="$t('common.confirm-dialog.title')"
			:message="$t('common.confirm-dialog.text')"
			:titleOk="$t('common.dialog-buttons.delete')"
			:titleCancel="$t('common.dialog-buttons.cancel')"
			@confirmed="deleteItem()" />
	</v-row>	
</template>
  
<script>
import BaseModule from '../common/BaseModule.js';
import ConfirmDialog from '../common/ConfirmDialog.vue';
import api from '../../api/humanway.js';

export default {
	name: 'ConfigDialog',
	mixins: [BaseModule],
	components: {
		ConfirmDialog
	},
	data() {
		return {
			showDialog: false,
			loading: false,
			showError: false,
			data: {},
		}
	},
	methods: {
		onWheel(event) {
			event.stopPropagation();
		},
		open(action, payload) {
			this.showError = false;
			this.showDialog = true;

				if (this.$refs.form) {
					this.$refs.form.resetValidation();
				}

				if (!payload) {
					this.data = {
						client: false,
						encrypted: false
					};
					return;
				}

				this.loading = true;

				api.getConfig(payload, 
				res => {
					this.data = res;
					this.loading = false;
				}, 
				error => {
					this.$log.error(error);
					this.$emit('show-alert', { text: error, color: 'error' });
					this.loading = false;
				}
			);
		},
		existsConfig(msgCb) {
			this.loading = true;

			api.existsConfig(this.data, 
				res => {
					this.loading = false;
					if (res) {
						this.showError = true;
						return;
					}
					
					this.showError = false;
					if (msgCb) {
						msgCb();
					}
				},
				error => {
					this.$log.error(error);
					this.loading = false;
					this.$emit('show-alert', { text: error, color: 'error' });
				}
			);
		},
		onSave() {
			if (!this.$refs.form.validate()) {
				return;
			}

			this.existsConfig(() => {
				this.storeConfig();
			});
		},
		storeConfig() { 
			this.loading = true;

			api.storeConfig(this.data, 
				() => {
					this.loading = false;
					this.showDialog = false;
					this.$emit('refresh');
				},
				error => {
					this.$log.error(error);
					this.loading = false;
					this.$emit('show-alert', { text: error, color: 'error' });
				}
			);
		},
		confirmDelete() {
				this.$refs.dlgConfirm.confirm(this.data);
		},
		deleteItem() {
			this.loading = true;
			
			api.deleteConfig(this.data.id, 
				() => {
					this.showDialog = false;
					this.loading = false;
					this.$emit('refresh');
				},
				error => {
					this.$log.error(error);
					this.loading = false;
					this.$emit('show-alert', { text: error, color: 'error' });
				}
			);
		}
	},
}
</script>